import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import ValidateResetPasswordTokenMutation from './ValidateResetPasswordTokenMutation';

const ValidateResetPasswordTokenConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(ValidateResetPasswordTokenMutation);

  const createValidateToken = async (request) => {
    const variables = request;

    const response = await mutate({
      variables,
    });

    return response;
  };

  return children({
    validateToken: createValidateToken,
    loading,
  });
};

ValidateResetPasswordTokenConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ValidateResetPasswordTokenConnectorApollo;
